module.exports = "./img/desktop_logo.32064e9.png";